import React from 'react';

import styles from './Button.module.css';
import { ButtonProps } from './Button.types';

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}) => {
  const classNames =
    `${styles.btn} ${styles[variant]} ${fullWidth ? styles.fullWidth : ''} ${className}`.trim();
  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
};
